export default __webpack_public_path__ + "static/1878-cce1cf0a0d2138348716b54f84cfa66a.gif";